const Section = (props) => {
  return (
    <section id={props.id} className="section">
      <div className="section__title">
        <span className="section__tag-2-o">&lt;h2&gt;</span>
        <h2>{props.title}</h2>
        <span className="section__tag-2-c">&lt;/h2&gt;</span>
      </div>
      {props.children}
    </section>
  );
};

export default Section;
